import { render, staticRenderFns } from "./ExamCategory.vue?vue&type=template&id=db842630"
import script from "./ExamCategory.vue?vue&type=script&lang=js"
export * from "./ExamCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports